module.exports = __webpack_public_path__ + "img/emoji_22.97866d31.png";